import React from "react";

export const WatermarkIcon = () => {
  return (
    <svg
      width="348"
      height="421"
      viewBox="0 0 348 421"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          d="M24.7762 0.32967L243.159 45.8561L241.457 49.485L241.457 49.4855L224.463 85.9141L224.734 86.0409L224.463 85.9141L178.444 184.576L78.7701 163.808L78.7688 163.808C62.0528 160.4 46.5103 152.594 33.6953 141.171C-4.77153 106.753 -12.9652 43.993 24.7762 0.32967Z"
          stroke="white"
          strokeWidth="0.6"
        />
        <path
          d="M338.181 191.869L338.18 191.87L327.161 215.455L322.594 214.515L322.593 214.514L225.318 194.27L225.257 194.564L225.318 194.27L179.057 184.651L224.981 85.9433L224.981 85.943L241.977 49.5152L241.977 49.5147L243.738 45.7577L268.376 50.9132L268.377 50.9134C282.106 53.7493 295.077 59.5399 306.418 67.8957L306.418 67.896L306.429 67.9034C307.223 68.4355 308.003 69.0201 308.767 69.6242L308.767 69.6245C309.909 70.5242 311.067 71.4584 312.174 72.3752C312.175 72.3762 312.176 72.3771 312.177 72.3781L313.998 73.9853L313.999 73.9857C314.509 74.434 315.032 74.9146 315.503 75.3933L317.211 77.128L318.904 78.8478L318.994 78.9696L319.007 78.9867L319.022 79.0018C333.325 93.4866 342.85 112.123 346.281 132.34C349.713 152.556 346.883 173.356 338.181 191.869Z"
          stroke="white"
          strokeWidth="0.6"
        />
        <path
          d="M322.462 215.1L322.461 215.1L225.186 194.857L178.787 185.208L135.451 278.059L322.462 215.1ZM322.462 215.1L326.889 216.012M322.462 215.1L326.889 216.012M326.889 216.012L231.659 420.117C156.593 425.895 103.235 347.227 135.451 278.059L326.889 216.012Z"
          stroke="white"
          strokeWidth="0.6"
        />
      </g>
    </svg>
  );
};
